const GLOBAL = {
    QUOTA: 'Cuota',
    ENTRY: 'Entrada',
    TERM: 'Plazo',
    OFFER: 'Ofertas',
    WHATSAPP: 'Whatsapp',
    SAVE: 'Guardar',
    CLIENT: 'Cliente',
    MONTHS: 'meses',
    CONFIRM: 'Confirmar',
    CALL: 'Llamar',
    EMAIL: 'correo electrónico',
    PASSWORD: 'contraseña',
    DELETE: 'borrar',
    TAB_COMPLETE: 'COMPLETAS',
    TAB_IN_PROCESS: 'EN PROCESO',
    TAB_INCOMPLETE: 'INCOMPLETAS',
    TAB_PENDING: 'PENDIENTES',
    TAB_STATUS: 'ESTADO',
    TAB_OBSERVATIONS: 'OBSERVACIONES',
    ORDER_BY: 'ORDENAR POR:',
    SEARCH: 'Buscar',
    SEARCH_NAME_ID: 'Buscar nombre / ID',
    ADD: 'Adicionar',
    BACK: 'Atrás',
    ACCEPT: 'Aceptar',
    DONT_SHOW_AGAIN: 'no volver a mostrar',
    SEND: 'Enviar',
    CONTINUE: 'Continuar',
    NAME_LASTNAME: 'Nombre y apellidos',
    NAME: 'Nombres',
    LASTNAME: 'Apellidos',
    PHONE: 'Teléfono celular',
    EDIT: 'EDITAR',
    CHANGE: 'Cambiar Cuenta',
    ADD_ACCOUNT: 'Agregar Cuenta',
    EDIT_ACCOUNT: 'Editar Cuenta',
    NO_RESULTS: 'No se encontraron resultados…',
    CLOSE: 'Cerrar',
    UPDATE_AVAILABLE: 'Actualización disponible',
    UPDATE_MESSAGE: 'Existe una nueva versión para Motorfy, para continuar usando sus servicios actualiza a la' +
        ' nueva versión.',
    UPDATE_NOW: 'Actualizar ahora',
    SELECT: 'Selecciona',
    ALL: 'Todos',
    SAVING: 'Guardando…',
    SERVER_ERROR_MESSAGE: '<b>Existió un error en el servidor</b><br>Por favor inténtelo en unos momentos',
    PROJECT_NAME: 'Admin'
};

const LOGIN = {
    START_SESSION: 'Inicia sesión',
    START_SESSION_DETAIL: 'Accede a tu cuenta de Administrador Motorfy.',
    START_SESSION_WITH_FORGOT_DETAIL: 'Enviamos las instrucciones para el reinicio de contraseña a tu ' +
        'correo electrónico.',
    BUTTON_START_SESSION: 'Iniciar sesión',
    BUTTON_REGISTER: 'Regístrate',
    FORGET_PASSWORD: '¿Olvidaste la contraseña?',
    NO_ACCOUNT: '¿No tienes cuenta?',
    FORGET_PASSWORD_TITLE: '¿Olvidaste tu contraseña?',
    FORGET_PASSWORD_SUBTITLE: 'Introduce tu correo electrónico, enviaremos un enlace para reiniciar tu contraseña ' +
        'de Administrador Motorfy.',
    RESET_PASSWORD: 'Reiniciar contraseña',
    GO_BACK_LOGIN: 'Volver al Inicio de sesión',
    SIDE_TITLE: 'FINANCIAMIENTO EN LÍNEA',
    SIDE_DETAIL: 'La plataforma que te permite comprar el auto de tus sueños a crédito con las mejores condiciones ' +
        'del mercado.',
    SIDE_SN: 'Con el respaldo de',
    SIDE_TIMER_TITLE: 'Aprobación en horas',
    SIDE_TERM_TITLE: 'Hasta 48 meses plazo',
    SIDE_TAX_118_TITLE: 'Tasa desde 1.18%**',
    SIDE_CASHDOWN_TITLE: 'Desde 20% de enganche',
    SIDE_AVAL_TITLE: 'Sin aval',
    SIDE_ELEVEN_YEARS_TITLE: 'Vehículos hasta 11 años',
    RESTART_SESSION: 'Ocurrió un error. Porfavor vuelva a Iniciar sesión',
};

const LOAN_APPLICATION = {
    TITLE: 'Solicitudes de crédito',
    SUBTITLE: 'No tienes solicitudes $name, inicia una solicitud desde la calculadora de cuotas.',
    INIT_LOAN: 'Inicia una solicitud',
    LOAN_STATUS: 'Estado de la solicitud',
    LOAN_CONTINUE: 'Continuar Solicitud',
    SAVE_CONTACT: 'Guardar contacto',
    CALL_CLIENT: 'Llamar al solicitante',
    CALL_CONCIERGE: 'Llamar al asesor ',
    TAB_MESSAGE_EMPTY: 'No tienes mensajes en esta solicitud.',
    TAB_MESSAGE: 'Mensajes',
    TAB_STATUS: 'Estatus',
    TAB_DETAIL: 'Detalles',
    TAB_MESSAGE_ID: 'messages',
    TAB_STATUS_ID: 'statuses',
    TAB_DETAIL_ID: 'details',
    FOLLOWING: 'Siguiente',
    FINISH: 'Finalizar',
    FIRST_NAME: 'Primer nombre',
    LAST_NAME: 'Apellido paterno',
    BIRTH_DATE: 'Fecha de nacimiento',
    CIVIL_STATUS: 'Estado civil',
    CELL_PHONE: 'Celular',
    EMAIL: 'Correo Electrónico',
    DOC_NUMBER: 'Cédula de identidad',
    PARTNER_DOC_NUMBER: 'Cédula de identidad Cónyugue',
    EMPLOYMENT_TYPE: 'Tipo de relación laboral',
    TOTAL_INCOME_MONTHLY: 'Total de ingresos mensuales',
    REAL_STATE: 'Bienes raíces',
    VEHICLES: 'Vehículos',
    APPLICANT_DATA: 'Datos del solicitante',
    PERSONAL_INTERVIEW_DATA: 'Entrevista personal',
    CURRENT_EMPLOYMENT: 'Empleo actual',
    LAST_EMPLOYMENT: 'Empleo Anterior',
    BANK_ACCOUNT_DATA: 'Información de Fondeo',
    COMMISSION_BANK_ACCOUNT_DATA: 'Comisión',
    BUREAU_DATA: 'Historial de crédito',
    LOAN_APPLICATION_PDF: 'Solicitud de crédito',
    LOAN_APPLICATION_CC_PDF: 'Reporte Historial Crediticio',
    LOAN_APPLICATION_MOTORFY_PDF: 'Solicitud de crédito Motorfy',
    QUOTATION_PDF: 'Cotización',
    INSURANCE_PDF: 'Seguro',
    GPS_PDF: 'GPS',
    BANK_ACCOUNT_PDF: 'Carátula de fondeo',
    ERROR_MESSAGE_PREVIEW_PDF: 'Tienes campos sin completar necesarios para generar el documento, ' +
        'agrega los campos faltantes para continuar.',
    ERROR_MESSAGE_PREVIEW_COPPEL_PDF: 'Esta solicitud aún no cuenta con la PREAUTORIZACIÓN DE COPPEL',
    EDIT_DEAL: 'Editar negocio',
    SPOUSE_APPLICANT_DATA: 'Datos del Cónyugue',
    ECONOMIC_INFORMATION: 'Información económica',
    FINGER_CLIENT: 'Firma del cliente',
    APPLICANT_AVALUO: 'Avalúo de bienes personales',
    TITLE_SENT: 'Solicitud enviada',
    TITLE_EQUIFAX: 'Solicitud rechazada',
    START_LOAN: 'Nueva solicitud',
    GOT_TO_SUMMARY: 'Ver Resumen',
    SUMMARY: 'Resumen',
    CHECK_EQUIFAX: 'Declaro haber leido integramente los términos y condiciones del servicio Motorfy contenidos' +
        ' dentro del portal web solicitudes.motorfy.com, los cuales acepto en su totalidad.',
    FINGER_SIGN: 'Utiliza tu dedo para firmar en esta zona',
    EQUIFAX_AUTH: ' autorizo a PatioTuerca.com (Avisoriaweb) y/o a las instituciones financieras y no ' +
        'financieras con las que trabaja a consultar mi historial crediticio',
    ECONOMIC_INFO_DETAIL: 'Incluye un promedio del total de ingresos mensuales  de tu núcleo familiar, entre' +
        ' salarios, comisiones, bonos, así como el avalúo de tus activos, esto ayudará a evaluar la capacidad de' +
        ' endeudamiento.',
    MONTHLY_QUOTA: 'cuota mensual',
    FILTER_TITLE: 'Filtrar',
    FILTER_BUTTON: 'FILTRAR',
    CLEAN_FILTER_BUTTON: 'LIMPIAR FILTRO',
    FILTER_STATUS_LABEL: 'Estatus',
    FILTER_BUTTON_CLEAN_LABEL: 'Restablecer',
    FILTER_BUTTON_LABEL: 'Ver Resultados',
    NO_SELECTED_DEAL: 'Ningún negocio seleccionado',
    ADVISER: 'Asesor',
    ORIGIN_ENTITY: 'Entidad de origen',
    FINISH_ENTITY: 'Entidad de cierre',
    CLOSING_ADVISER: 'Asesor de cierre',
    RECORD_STATUS: 'Estado Expediente',
    INSTALLATION_GPS_STATUS: 'Estado de Instalación del GPS',
    CARD_COMMISSION_ACCOUNT_STATUS: 'Tarjetas para pago de comisión',
    SALESFORCE_COMMISSION_PAYMENT_STATUS: 'Estado de Pago',
    PIPELINE: 'Pipeline',
    STAGE: 'Stage',
    SENT_TO_CR: 'Enviados a Crédito Real',
    LOAN_APPLICATION_TYPE: 'Tipo de solicitud',
    CHANNEL: 'CANAL',
    TARGET: 'Financiera',
    FINANCIAL_ENTITY_TYPE: 'Entidad de origen',
    CAN_NOT_SEND_LOAN_APPLICATION_LBL: 'No es posible enviar al Banco',
    PRE_AUTHORIZATION_PDF: 'Preautorización Coppel',
    OPENING_COMMISSION_PDF: 'Carta de Autorización',
    DEPOSIT_LETTER_PDF: 'Carta de Fondeo',
};

export const LOAN_APPLICATION_DETAIL = {
    SAVING: 'Guardando…',
    LAST_UPDATE: 'Últ. modificación:'
};

const LOAN_APPLICATION_MX = {
    SHARE_BUTTON: 'Compartir Cotización',
    APPLICANT_DATA_MESSAGE: 'Completa este formulario con tus datos reales, no te tomará más de 10 minutos,' +
        ' ten en cuenta que de esto dependerá la aprobación de tu crédito.',
    FIRST_NAME: 'Primer nombre',
    NAME: 'Nombre',
    SECOND_NAME: 'Segundo nombre',
    LAST_NAME: 'Apellido paterno',
    SECOND_LAST_NAME: 'Apellido materno',
    BIRTH_DATE: 'Fecha de nacimiento',
    RFC_NUMBER: 'RFC',
    RFC_WITH_HOMOKEY: 'RFC con Homoclave',
    CELL_PHONE: 'Celular',
    EMAIL: 'Correo Electrónico',
    GENDER: 'Género',
    CIVIL_STATUS: 'Estado civil',
    STUDIES_LEVEL: 'Nivel de estudios',
    ECONOMIC_DEPENDENTS: 'Dependientes Económicos',
    ALREADY_HAS_VEHICLE: 'Cuenta con vehículo',
    ALLOW_LOWER_PERCENT: 'Activar otro porcentaje de Enganche',
    NIP: 'Código de verificación',
    NIP_IDENTITY: 'Código de validación',
    SELECT_INSURANCE_TEXT: 'Selecciona el seguro al que el solicitante desea aplicar.',
    SELECT_BUREAU_TEXT: 'Selecciona las opciones que se ajusten al solicitante.',
    INCLUDE_INSURANCE: 'Pago del seguro',
    COMPLETE_NAME: 'Nombre y Apellidos',
    REFERENCE_COMPLETE_NAME: 'Nombre completo',
    CREDIT_CARD_LAST_NUMBERS: '4 últimos dígitos de la tarjeta',
    SCHEDULE_CONTACT: 'Tipo de Teléfono',
    CONTACT_TIME: 'Horario de Contacto',
    CONTACT_NUMBER: 'Número de Contacto',
    PHONE_EXTENTION: 'Extensión',
    REFERENCE_TITLE: 'Referencia',
    REFERENCE_DESCRIPTION: 'Agrega 3 referencias, esto nos ayudará a evaluar tu historial crediticio.',
    MORE_INFO: 'más info',
    BUREAU: 'Buró',
    NEXT: 'Siguiente',
    UPDATE: 'Actualizar',
    CALL_CLIENT: 'Llamar al Solicitante',
    ASK_NIP: 'Solicitar Código',
    VALIDATE_NIP: 'Validar código',
    SKIP_IDENTITY_VALIDATION: 'Continuar sin validar',
    IDENTITY_VALIDATION_MSG: 'Asegúrate de ingresar tus datos correctamente. Enviaremos un código a tu correo y ' +
        'celular para validar tu identidad e historial de crédito.',
    NIP_VALIDATION_LEGAL_MSG: 'Al ingresar el código aceptas el uso de tus datos personales.',
    BUREAU_VALIDATION_LEGAL_MSG: 'Al ingresar el código autorizas que consultemos tu historial de crédito.',
    SKIP_NIP: 'Omitir verificación',
    RESEND_NIP_IN: 'reenviar código en',
    RESEND_NIP: '¿No recibiste el Código? reenviar',
    EDIT_FOR_NIP: 'Editar contacto',
    BUREAU_TITLE_SORRY: 'Lo sentimos',
    BUREAU_SORRY_MESSAGE: 'Tu solicitud de crédito no se ajusta a los requisitos de la financiera, debido a tu ' +
        'historial crediticio.',
    BUREAU_SORRY_INVITATION_LONG_TEXT: 'Te invitamos a que lo intentes en un futuro cercano.',
    NIP_QUERY_ERROR: 'Error de consulta',
    NIP_QUERY_MESSAGE: 'Estimado $name, ingresa el código de validación que enviamos al correo $email y al $phone.',
    NIP_QUERY_ERROR_MESSAGE: 'No hemos podido consultar tu historial crediticio.',
    NIP_QUERY_ERROR_INPUT_DATA: 'Por favor ingresa los siguientes datos para que podamos realizar la consulta.',
    NIP_TITLE_ALREADY_VALIDATED: 'Validación Exitosa',
    NIP_CONGRATULATIONS_ALREADY_VALIDATED: 'Felicidades $name, estás un paso más cerca de tener tu $desiredVehicle.',
    NIP_MESSAGE_ALREADY_VALIDATED: 'Consultamos tu historial crediticio. Ahora puedes continuar con tu' +
        ' solicitud de crédito.',
    NIP_BUREAU_MESSAGE: 'Estimado $name, ingresa nuevamente el código de validación de identidad que te ' +
        'enviamos anteriormente.',
    IDENTITY_VALIDATED_MESSAGE: 'Has aceptado el uso de tus datos personales para esta solicitud de crédito.',
    ANNUAL: {
        id: 'ANNUAL',
        value: 'Anual'
    },
    MULTI_YEAR: {
        id: 'MULTI_YEAR',
        value: 'Multianual'
    },
    DOMICILE_ADDRESS: 'Dirección',
    DOMICILE_EXTERNAL_NUMBER: 'Nro. Ext',
    DOMICILE_INTERNAL_NUMBER: 'Nro. Int',
    DOMICILE_POSTAL_CODE: 'Código Postal',
    DOMICILE_STATE: 'Estado',
    DOMICILE_CITY: 'Ciudad',
    DOMICILE_MUNICIPALITY: 'Delegación o Municipio',
    DOMICILE_COLONY: 'Colonia',
    HOUSE_TYPE: 'Tipo de domicilio',
    HOLDING_RESIDENCE_TITLE_TYPE: 'Tipo de Vivienda',
    DOMICILE_RESIDENCE_YEARS: 'Años de Residencia',
    DOMICILE_MONTHLY_RENT: 'Pago de renta mensual',
    DOMICILE_PHONE: 'Teléfono con clave lada',
    EMPLOYMENT_VALIDATE_INCOMES: '¿Puede Validar sus Ingresos?',
    EMPLOYMENT_TYPES: 'Situación laboral',
    EMPLOYMENT_COMPANY_NAME: 'Empresa donde Labora',
    EMPLOYMENT_POSITION: 'Cargo',
    EMPLOYMENT_START_DATE: 'Inicio de Actividad Laboral',
    EMPLOYMENT_END_DATE: 'Fecha de separación',
    EMPLOYMENT_ADDRESS: 'Dirección',
    EMPLOYMENT_EXTERNAL_NUMBER: 'Nro. Ext',
    EMPLOYMENT_INTERNAL_NUMBER: 'Nro. Int',
    EMPLOYMENT_POSTAL_CODE: 'Código Postal',
    EMPLOYMENT_STATE: 'Estado',
    EMPLOYMENT_CITY: 'Ciudad',
    EMPLOYMENT_MUNICIPALITY: 'Delegación o Municipio',
    EMPLOYMENT_COLONY: 'Colonia',
    EMPLOYMENT_HOUSING_TYPE: 'Tipo de Vivienda',
    EMPLOYMENT_MONTHLY_INCOME: 'Ingreso Mensual',
    EMPLOYMENT_PHONE: 'Teléfono de empleo',
    EMPLOYMENT_PHONE_EXT: 'Extensión',
    EMPLOYMENT_DOCUMENT_TYPE: 'Tipo de Comprobante de Ingresos',
    EMPLOYMENT_BUSINESS_TYPE: 'Tipo de Establecimiento',
    EMPLOYMENT_BILLING: 'Facturación',
    EMPLOYMENT_TAX_REGIME: 'Régimen Fiscal',
    EMPLOYMENT_BILLING_FILE_MISSING: 'No olvides subir el pdf que acredite el régimen fiscal del cliente desde la pestaña "Adjuntos", como tipo de documento "Constancia de Situación Fiscal"',
    EMPLOYMENT_BILLING_FILE_EXISTS: dateTime => `Se ha subido la Constancia de Situación Fiscal con éxito. Realizado el: ${dateTime}`,
    EQUIFAX_AUTH: ' garantizo que ésta rúbrica digital corresponde con el registrado en el INE / IFE, y podrá ' +
        'ser utilizada para los fines de esta solicitud de crédito.',
    FINGER_SIGN: 'Utiliza tu dedo para firmar en esta zona',
    HOUSE_HOLD: 'Arraigo',
    COVERAGE: 'Coberturas',
    ACCEPT_TERMS: 'El solicitante acepta los términos y condiciones para la consulta de buró de crédito',
    SUMMARY: 'Resumen',
    SUMMARY_DESIRED_VEHCILE: 'Solicitud de crédito para un ',
    SUMMARY_MONTHLY_INCOME: 'MENSUALIDAD ESTIMADA',
    SUMMARY_DETAIL_COMMISSION: 'Comisión de apertura (3%)',
    SUMMARY_MONTHLY_PAYMENT: 'Mensualidad*',
    SUMMARY_MONTHLY_INSURANCE: 'Seguro estimado',
    SUMMARY_NOTE_MONTHLY_PAYMENT: '*La mensualidad puede cambiar dependiendo del perfil del cliente, ubicación' +
        ' y modelo del vehículo a financiar.',
    SUMMARY_NOTE_TRACKING_DEVICE: 'Incluye: seguros, dispositivo de rastreo y gastos varios.',
    STATE: 'Estado',
    STATE_ALL: 'Todos los estados',
    STATE_FILTER_PLACEHOLDER: 'Estado de residencia del solicitante',
    MONTHLY_QUOTA: 'mensualidad',
    EMPLOYMENT_CHECK_MENSUAL_INCOME: '¿El solicitante puede comprobar sus ingresos?',
    CREDIT_HISTORY: 'Historial de crédito',
    CREDIT_HISTORY_SELECT_TEXT: 'Selecciona las respuestas que se ajustan a tu historial crediticio.',
    CREDIT_HISTORY_CHECK_VEHICULAR_CREDIT: '¿Tiene o ha tenido un crédito vehicular?',
    CREDIT_HISTORY_CHECK_MORTGAGE: '¿Tiene o ha tenido un crédito hipotecario?',
    CREDIT_HISTORY_CHECK_CREDIT_CARD: '¿Tiene una tarjeta de crédito vigente?',
    NOTICE_OF_PRIVACY: 'Aviso de privacidad',
    NOTICE_OF_PRIVACY_OPTION: 'He leído y comprendo el aviso de privacidad',
    NOTICE_OF_PRIVACY_BTN: 'he leído el aviso',
    BUREAU_AUTHORIZATION: 'Autorización de buró',
    BUREAU_AUTHORIZATION_OPTION: 'He leído los términos y condiciones para la consulta de buró de crédito',
    BUREAU_AUTHORIZATION_BTN: 'He leído la autorización',
    REFERENCE_1: 'Referencia 1',
    REFERENCE_2: 'Referencia 2',
    REFERENCE_3: 'Referencia 3',
    FAMILY_REFERENCE: 'Referencia familiar',
    PERSONAL_REFERENCE: 'Referencias personales',
    KINSHIP: 'Parentesco',
    REFERENCE_TYPE: 'Tipo de referencia',
    REFERENCE_TIME_MEETING: 'Años de conocerse',
    ACTUAL_HOME: 'Domicilio actual',
    REFERENCES: 'Referencias',
    WORK_INFO: 'Información laboral',
    INSURANCE: 'Seguros',
    AMORTIZATION_INSURANCE_AMOUNT: isFinanced => `Seguro ${isFinanced ? 'Financiado' : 'de Contado'}`,
    INSURANCE_AMOUNT: 'Valor del seguro',
    INSURANCE_CARRIER: 'Aseguradora',
    INSURANCE_POLICY_NUMBER: 'Número de Póliza',
    INSURANCE_BITUAJ_FOLIO_COT: 'Folio Cotización',
    INSURANCE_POLICY_DATE_START: 'Fecha inicio',
    INSURANCE_POLICY_DATE_END: 'Fecha fin',
    INSURANCE_DRIVER: 'Conductor habitual',
    INSURANCE_AMOUNT_TO_INSURE: 'Valor a asegurar',
    INSURANCE_NET_PREMIUM_AMOUNT: 'Prima neta',
    INSURANCE_COMPANIES: 'Aseguradoras',
    INSURANCE_SELECT_COMPANY_TEXT: 'Selecciona la aseguradora a la que deseas aplicar.',
    INSURANCE_PERIOD_FINANCING_TEXT: 'El valor del seguro es por 1 año a ser financiado en todo el período del crédito',
    FINISHED_TITLE: 'Solicitud finalizada',
    FINISHED_CONGRATULATIONS: 'Felicidades $name, la solicitud de financiamiento para un $vehicle de $price ' +
        'será procesada por nuestros asesores.',
    FINISHED_CONTACT_1: 'Nos comunicaremos contigo al momento de recibir aprobación.',
    FINISHED_CONTACT_2_LONG_TEXT: 'Si tienes cualquier pregunta puedes contactarte al (55) 1455-4276.',
    FINISHED_MESSAGE: 'A continuación puedes ver tus datos enviados en la solicitud.',
    TITLE_FILE_UPLOAD: 'Carga de archivos',
    FILE_UPLOAD_DETAIL: 'Agilita el procesamiento de tu solicitud de crédito adjuntando los siguientes documentos' +
        ' en formato JPG, PNG o PDF, cada archivo debe pesar máximo 10Mb.',
    FILE_UPLOAD_IDENTIFICATION: 'Identificación oficial vigente',
    FILE_UPLOAD_IDENTIFICATION_EXAMPLE: 'Cargar IFE por ambos lados. ',
    FILE_UPLOAD_HOME: 'Comprobante de domicilio',
    FILE_UPLOAD_HOME_EXAMPLE: 'Con antiguedad máxima de 90 días, ej: Luz, agua, teléfono fijo, predial, ' +
        'gas natural, estados de cuenta bancarios y de servicios de televisión de paga o internet.',
    FILE_UPLOAD_OTHER: 'Comprobante de ingresos',
    FILE_UPLOAD_OTHER_EXAMPLE: 'Recibos de nómina o estados de cuenta con código QR de los ultimos 3 meses.',
    FILE_UPLOAD_BOX_FRONT: 'Subir Ife frente',
    FILE_UPLOAD_BOX_BACK: 'Subir Ife reverso',
    FILE_UPLOAD_HOME_BOX: 'Subir comprobante',
    FILE_UPLOAD_OTHER_BOX_1: 'Subir recibo último mes',
    FILE_UPLOAD_OTHER_BOX_2: 'Subir recibo mes previo',
    FILE_UPLOAD_OTHER_BOX_3: 'Subir recibo mes anterior',
    FILE_UPLOAD_IFE_SUGGESTION: 'Sube el frente y reverso del ife',
    FILE_UPLOAD_HOME_SUGGESTION: 'Sube un solo archivo',
    FILE_UPLOAD_OTHER_SUGGESTION: 'Sube 3 archivos, uno para cada mes',
    FILE_DETAIL_IFE_FRONT: 'IFE frente',
    FILE_DETAIL_IFE_BACK: 'IFE reverso',
    FILE_DETAIL_HOME: 'Comprobante',
    FILE_DETAIL_OTHER_BOX_1: 'Recibo último mes',
    FILE_DETAIL_OTHER_BOX_2: 'Recibo mes previo',
    FILE_DETAIL_OTHER_BOX_3: 'Recibo mes anterior',
    FILE_DETAIL_DOWNLOAD: 'DESCARGAR',
    FILE_DOWNLOAD_DOCUMENT: 'Descargar documento',
    FILE_DETAIL_CREATION: 'Creación',
    FILE_DETAIL_UPLOAD_BY: 'Cargado por',
    FILE_DELETE_CANCEL_BUTTON:'CANCELAR',
    FILE_DELETE_CONFIRM_BUTTON:'ELIMINAR ARCHIVO',
    FILE_DELETE:'ELIMINAR',
    FILE_DELETE_CONFIRM_TITLE:'¿Deseas eliminar el archivo?',
    FILE_CREATE_NEW_VERSION_CONFIRM_TITLE:'¿Crear nueva versión?',
    FILE_SEND_TO_BANK_CONFIRM_TITLE:'Confirmar envío de archivo',

    YEAR: 'Año',
    MONTH: 'Mes',
    DAY: 'Día',
    MONTHLY_GPS: 'GPS mensual',
    DEBT_BALANCE_INSURANCE: 'SEGURO SALDO DEUDOR',
    TRACKING: 'Instalación de GPS',
    TRACKING_ADDRESS: 'Dirección de instalación',
    TRACKING_CONTACT_NAME: 'Contacto para la instalación',
    TRACKING_CONTACT_PHONE: 'Teléfono de contacto',
    TRACKING_INSTALLATION_DATE: 'Fecha de instalación',
    TRACKING_INSTALLATION_STATUS: 'Estado de instalación del GPS',
    TRACKING_DEVICE: 'Dispositivo',
    MECHANICAL: 'Garantía mecánica',
    MECHANICAL_WARRANTY_TYPE: 'Tipo de garantía',
    MECHANICAL_WARRANTY_NO_WARRANTY_TYPE_ID: 'NO_WARRANTY',
    MECHANICAL_WARRANTY_FINANCED_TYPE_ID: 'FINANCED',
    MECHANICAL_WARRANTY_POLICY_NUMBER: 'Número de póliza',
    MECHANICAL_INCLUDE: 'Garantía mecánica',
    MECHANICAL_COVERAGE: 'Años de cobertura',
    MECHANICAL_COVERAGE_FIELD_TYPE: 'COVERAGE',
    MECHANICAL_POLICY_FIELD_TYPE: 'POLICY',
    MAX_FILE_MESSAGE : '<b>El tamaño máximo permitido de un archivo es 10 MB</b>',
    POINT_OF_SALE: 'Agencia/Lote',
    POINT_OF_SALE_NAME: 'Grupo',
    POINT_OF_SALE_MOTORFY_ID: 'Dealer Id',
    BANK_ACCOUNT_NAME: 'CUENTA PARA DESEMBOLSO',
    COMMISSION_BANK_ACCOUNT_NAME: 'CUENTA PARA DESEMBOLSO',
    COMMISSION_BANK_ACCOUNT_DEALER: 'Cuenta para comisión Dealer',
    COMMISSION_CARD_ACCOUNT_DEALER: 'Tarjeta para comisión de dealer',
    COMMISSION_BANK_ACCOUNT_DATE_REGISTER: 'Fecha Registro de Comisión',
    MIGRATE_LOAN_CONFIRM_BUTTON: 'SÍ, MIGRAR LA SOLICITUD',
    MIGRATE_LOAN_FINISH_BUTTON: 'ACEPTAR',
    MIGRATE_LOAN_CANCEL_BUTTON: 'CANCELAR',
    MIGRATE_LOAN_TITLE: '¿Deseas migrar la solicitud?',
    MIGRATE_LOAN_SUCCESS_TITLE: '¡Migración exitosa!',
    CHECK_BUREAU: 'Consultar Buró',
    BANK_ACCOUNT_INFORMATION: 'Información de fondeo',
    CLOSING_ADVISOR_TITLE: 'Asesor de cierre de crédito',
    RECORDS_TITLE: 'Expediente físico',
    RECORD_STATE: 'Estado',
    RECORD_DATE_SENT: 'Fecha de envío a Crédito Real',
    RECORD_DATE_OWNER_CHANGED: 'Fecha pago comisión por excepción',
    RECORD_DATE_DISBURSEMENT_DELAYED: 'Fecha desembolso tardío',
    RECORD_FILE_OWNER_CHANGED: 'Adjunto solicitar pago comisión',
    RECORD_DATE_RECEIVED: 'Fecha de recepción',
    RECORD_COMMENTS: 'Comentarios',
    RECORD_DELIVERY_TIME: 'Tiempo de entrega (días)',
    RECORD_COMPLETE_RECORD_TIME: 'Tiempo expediente completo (días)',
    RECORD_TOTAL_TIME: 'Tiempo total (días)',
    GIFT_CARDS_TITLE: 'Monedero',
    GIFT_CARD_BENEFICIARY: 'Para quién es el monedero',
    GIFT_CARD_AMOUNT: 'Valor del monedero',
    COMMISSION_BANK_ACCOUNT: 'Pago de comisión (Dealer)',
    CHECK_BUREAU_BUTTON: 'Consultar Buró',
    CHECK_BUREAU_LABEL: 'De clic para volver a consultar Buró',
    CHECK_BUREAU_COPPEL_LABEL: 'De clic para volver a consultar Buró desde Motorfy',
    VIEW_DETAILS_BANK_ACCOUNT: 'Ver detalles de la cuenta seleccionada',
    VIEW_DETAILS_CARD_ACCOUNT: 'Ver detalles de la tarjeta seleccionada',
    SELECT_BANK_ACCOUNT: 'Seleccione cuenta para desembolso',
    SELECT_COMMISSION_BANK_ACCOUNT: 'Seleccione cuenta',
    SELECT_COMMISSION_CARD_ACCOUNT: 'Seleccione tarjeta',
    BANK_APPLICATION: 'Consecutivo',
    CONTINUE_LOAN_APPLICATION: 'Email para continuar solicitud',
    CONTINUE_LOAN_APPLICATION_INFO: 'Se enviará un email al solicitante para que complete la solicitud',
    CONTINUE_LOAN_APPLICATION_BTN: 'Enviar Email',
    CONTINUE_LOAN_APPLICATION_NOT_ALLOWED_INFO: 'Disponible solo para solicitudes online incompletas',
    SEND_TO_CR_HEADER: 'Enviar a Crédito Real',
    SEND_TO_CR_LOAN_APPLICATION_BTN: 'Enviar a crédito real',
    SEND_TO_CR_LOAN_APPLICATION_INFO: 'Esta solicitud se enviará a crédito Real ',
    SEND_TO_CR_LOAN_APPLICATION_NOT_ALLOWED_INFO:
    'Disponible solo para solicitudes incompletas no aceptadas calculadora condicionada',
    SALESFORCE_TITLE: 'Salesforce',
    FINISH_TITLE: 'Finalizar Solicitud',
    FORCE_FINISH_TITLE: 'Cerrar Solicitud',
    CLOSING_BANK_TITLE: 'Cierre Financiero del Crédito',
    LOSE_TITLE: 'Perder Solicitud',
    LOST_TITLE: 'Solicitud Perdida',
    REOPEN_BUTTON: 'Reabrir',
    REOPEN_MODAL_TITLE: 'Reabrir solicitud',
    REOPEN_CONFIRM_MESSAGE: '¿Seguro que deseas reabrir la solicitud? Se devolverá a una condición abierta en Pipedrive.',
    REOPEN_ERROR_TITLE: 'No se pudo reabrir la solicitud',
    REOPEN_ERROR_DESCRIPTION: 'Intenta nuevamente en unos momentos.',
    REOPEN_PENDING_TITLE: 'Reapertura en proceso',
    REOPEN_PENDING_DESCRIPTION: 'La solicitud no aparece en el listado actual. Actualiza el listado en unos momentos para verificar el cambio.',
    CANCEL_BUTTON: 'Cancelar',
    ACCEPT_BUTTON: 'Aceptar',
    FINISHED_LABEL: 'Finalizada',
    NOT_FINISHED_LABEL: 'No Finalizada',
    LOST_LABEL: 'PERDIDA',
    FINANCING_AMOUNT_FIELD: 'Monto a financiar',
    REQUEST_ID_FIELD: 'ID de solicitud',
    AGENCY_FIELD: 'Agencia',
    CHANNEL_FIELD: 'Canal',
    FOLIO_FIELD: 'Folio',
    SALESFORCE_CANCEL_BUTTON: 'Cancelar Oportunidad',
    BIOMETRICS_TITLE: 'Biométricos',
    VALIDATION_ID_TITLE: 'Validación de Identificación',
    BIOMETRICS_RESET_BUTTON: 'Resetear',
    BIOMETRICS_DEACTIVATE_FINGERPRINTS_CAPTURE_BUTTON: 'Desactivar Captura Huellas',
    VALIDATION_ID_CREATE_BUTTON: 'Validar',
    VALIDATION_ID_REENTER_CURP: 'El Curp leido de la imágen no pudo ser validado, favor de rectificar para reprocesar la validación de identificación.',
    VALIDATION_ID_REENTER_OTHERS: 'Los siguientes datos leidos de la imágen no pudieron ser validados, favor de rectificarlos para reprocesar la validación de identificación.',
    VALIDATION_ID_REENTER_BUTTON: 'REENVIAR',
    VALIDATION_ID_RESET_BUTTON: 'Resetear',
    CURP: 'CURP',
    VALIDATION_ID_REENTER_OCR: 'OCR',
    VALIDATION_ID_REENTER_CIC: 'CIC',
    VALIDATION_ID_REENTER_ANIO_REGISTRO: 'Año De Registro',
    VALIDATION_ID_REENTER_FECHA_EMISION: 'Fecha Emision',
    VALIDATION_ID_REENTER_DUPLICADOS: 'Duplicados',
    VALIDATION_ID_REENTER_CLAVE_ELECTOR: 'Clave Elector',
    NATIONALITY: 'Nacionalidad',
    BIRTH_COUNTRY: 'País de Nacimiento',
    HOUSE_BETWEEN_STREET: 'Entre calle',
    HOUSE_BETWEEN_STREET_AND: 'Y',
    SEND_CR_INFO_TITLE: 'Enviar a Crédito Real',
    SEND_CR_INFO_SEND_BUTTON: 'ENVIAR A CRÉDITO REAL',
    SEND_MEDICI_VALIDATION_EMAIL_BUTTON: 'ENVIAR CORREO',
    SEND_CR_INFO_LABEL: 'De clic para enviar esta solicitud a Crédito Real',
    SEND_CR_INFO_REMINDER_LABEL: 'No olvides primero enviar la información xml a CR desde la pestaña "Edición" y luego el pdf "solicitud" desde la pestaña "Adjuntos".',
    COPPEL_TITLE: 'COPPEL',
    COPPEL_FOLIO: 'Folio',
    COPPEL_BUREAU: 'Buró',
    LOSE_APPLICATION_MOTIVE: 'Razón de la pérdida',
    COPPEL_BANK: 'COPPEL',
    CREDITAS_BANK: 'CREDITAS',
    RAPIDAUTO_BANK: 'RAPIDAUTO',
    CLOSING_BANK: 'Financiera de Cierre',
    CLOSING_BANK_COPPEL_ERROR: 'La Financiera de Cierre debe ser Coppel para poder generar la Carta de Autorización',
    CLOSING_BANK_DEPOSIT_LETTER_ERROR: 'La Financiera de Cierre debe ser Coppel/Creditas/Rapidauto para poder generar la Carta de Fondeo',
    CLOSING_BANK_BLOCKED_MESSAGE: 'Esta solicitud ya caducó, no es posible modificar la financiera de cierre.',
    APPROVAL_CONDITIONS_TITLE: 'Condiciones de aprobación',
    APPROVAL_CONDITIONS_RATE: 'Tasa',
    APPROVAL_CONDITIONS_INITIAL_DOWN_PAYMENT: 'Enganche inicial',
    APPROVAL_CONDITIONS_APPROVED_DOWN_PAYMENT: 'Enganche aprobado',
    APPROVAL_CONDITIONS_TERM_OTHER_OPTION: 'Otro',
    APPROVAL_CONDITIONS_TERM_OTHER_LABEL: 'Nuevo plazo',
    APPROVAL_CONDITIONS_TERM_OTHER_HELP: 'Min:10 | Max:99 pagos',
    APPROVAL_CONDITIONS_TERM_OTHER_ERROR: 'El plazo debe ser un número de 2 dígitos (10 a 99 pagos).',
    APPROVAL_CONDITIONS_TERM_ALREADY_EXISTS: 'Ese valor ya existe en el catálogo estándar, se seleccionó del listado.',
    APPROVAL_CONDITIONS_WARNING_MESSAGE: 'Estos campos son opcionales, pero te recomendamos completarlos: ' +
        'la Tasa, el Plazo y los Enganches son información clave para los reportes ejecutivos y el análisis ' +
        'con financieras.',
    APPROVAL_CONDITIONS_BLOCKED_MESSAGE: 'Esta solicitud ya caducó, no es posible modificar las condiciones de aprobación.',
};

export const CREDIT_CONDITION = {
    PAYMENTS: ' pagos',
    CUSTOMER_TYPE_SEPARATOR: ' - '
};

const CALCULATOR = {
    TITLE_1: 'Calcula tus cuotas',
    TITLE_2: 'las cuotas ideales',
    INCLUDES: 'INCLUYE',
    INSURANCE: 'Seguro Vehicular',
    TRACKING: 'Dispositivo de rastreo',
    INSPECTION: 'Gastos de inspección',
    COST: 'Costo de avaluo',
    LEGAL: 'Gasto de legalización',
    BRAND_MODEL_YEAR: 'Marca, Modelo y Año',
    BRAND: 'Marca',
    MODEL: 'Modelo',
    YEAR: 'Año',
    VERSION: 'Versión',
    ASSEMBLY_COUNTRY: 'Orígen de vehículo',
    CHASSIS: 'Chasis / Vin',
    PRICE: 'Precio del vehículo',
    ENTRY: 'Entrada',
    DOWN_PAYMENT: 'Enganche',
    TERMS: 'Plazo',
    DISCOUNT: 'Condiciones de Crédito',
    PROFILE: 'Perfil',
    CLIENT_TYPE: 'Tipo de cliente',
    OPPENING_COMMISSION: 'Comisión por apertura - empresa',
    LIFE_INSURANCE_GPS: 'GPS/SDV',
    QUOTAS: 'Cuotas financiadas mensuales',
    START_LOAN: 'Inicia tu solicitud de crédito',
    AMOUNT_FINANCE: 'Valor a financiar',
    VEHICLE_DATA: 'Datos del vehículo',
    VEHICLE_DATA_BITUAJ: 'Datos del vehículo [Bituaj]',
    VEHICLE_DATA_FARRERA: 'Datos del vehículo [Farrera]',
    VEHICLE_DATA_SEMINUEVOS: 'Datos del vehículo [Seminuevos]',
    CREDIT_DATA: 'Condiciones del crédito',
    UPDATE: 'Actualizar',
    MILEAGE: 'Kilometraje',
    OUTLAY_DATE: 'Fecha de Desembolso',
    SIGNATURE_DATE: 'Fecha de Firma',
    EXTERNAL_VEHICLE_URL: 'VEHÍCULO - URL (CANAL ONLINE)'
};

const CALCULATOR_MX = {
    YEAR_PLACEHOLDER: '¿Cuál es el año?',
    YEARS: 'Años',
    BRAND_PLACEHOLDER: '¿Marca del vehículo?',
    BRANDS: 'Todas las marcas',
    MODEL_PLACEHOLDER: '¿Modelo del vehículo?',
    MODELS: 'Todos los modelos',
    VERSION_PLACEHOLDER: '¿Versión del vehículo?',
    VERSIONS: 'Todas las versiones',
    ANNUAL_INSURANCE: 'Seguro anual',
    ANNUAL_INSURANCE_INCLUDED_MONTHLY_PAYMENT: 'Incluido en la mensualidad',
    FINANCING_CONDITIONS: 'Condiciones del crédito',
    FINANCING_AMOUNT: 'Monto a financiar',
    FINANCING_AMOUNT_WITH_INSURANCE_AND_WARRANTY: 'Monto a financiar con seguro',
    FINANCING_AMOUNT_DETAIL: 'Precio del vehículo - Enganche',
    FINANCING_AMOUNT_DETAIL_INSURANCE_ANUAL: ' + Seguro anual',
    FINANCING_AMOUNT_DETAIL_INSURANCE: ' + Seguro',
    FINANCING_AMOUNT_DETAIL_WARRANTY: ' + Garantía',
    MONTHLY_PAYMENTS: 'Mensualidad',
    MONTHLY_PAYMENTS_DETAIL: 'Selecciona el número de mensualidades al que deseas aplicar.',
    COMMISSION_AMOUNT: 'Comisión apertura {{percentage}} + IVA',
    COMMISSION_AMOUNT_DETAIL: '{{percentage}} + IVA del valor del monto a financiar',
    CASH_PAYMENTS: 'PAGOS DE CONTADO',
    TITLE_DETAIL: 'Agrega los detalles del vehículo que deseas financiar a través de Motorfy',
};

const SUMMARY_MX = {
    CREDIT_CONDITIONS: 'Condiciones del crédito',
    VEHICLE: 'Vehículo',
    PRICE: 'Precio',
    DOWN_PAYMENT: 'Enganche',
    STATE: 'Estado',
    AMOUNT_FINANCE: 'Monto a financiar',
    TERM: 'Plazo',
    APPLICANT_DATA: 'Datos del solicitante',
    MONTHLY_PAYMENTS: 'Mensualidades',
    COMPLETE_NAME: 'Nombres completos',
    BIRTH_DATE: 'Fecha de nacimiento',
    RFC: 'RFC',
    CELL_PHONE: 'Celular',
    ACTUAL_HOME: 'Domicilio actual',
    EMAIL: 'Correo electrónico',
    ADDRESS: 'Dirección',
    NRO_EXT: 'Nro. Ext',
    NRO_INT: 'Nro. Int',
    POSTAL_CODE: 'Código postal',
    CITY: 'Ciudad',
    MUNICIPALITY: 'Delegación o municipio',
    COLONY: 'Colonia',
    PHONE_WITH_LADA: 'Teléfono con clave lada',
    WORK_INFO: 'Información Laboral',
    WORKPLACE: 'Empresa donde labora',
    POSITION: 'Cargo',
    WORKING_SINCE: 'Inicio de actividad laboral',
    PHONE_NUMBER: 'Número de teléfono',
    EXTENSION: 'Extensión',
    MONTHLY_INCOME: 'Ingreso mensual',
    REFERENCES: 'Referencias',
    INSURANCE: 'Seguro',
    INSURANCE_PAYMENT: 'Pago del seguro',
    INSURANCE_CARRIER: 'Aseguradora',
    ANNUAL_INSURANCE: 'Seguro anual',
    INSURANCE_FINANCED: 'Incluido en el financiamiento',
    INSURANCE_CASH: 'De contado',
    SUBTITLE: 'Enviaremos tu solicitud de financiamiento para un $desiredVehicle de $price para su aprobación.'
};

const NOTIFICATIONS = {
    TITLE: 'Avisos',
    TITLE_EMPTY: 'No tienes avisos nuevos',
    NEW_NOTIFICATIONS: 'Tienes nuevos avisos',
    NO_INTERNET: 'Sin conexión a internet, reconectando…',
    CONNECTED: 'Conectado'
};

const PROFILE = {
    SETTINGS: 'Configuración',
    CALL_CONCIERGE: 'Llamar a asesor Motorfy',
    CHANGE_PASSWORD: 'Cambiar contraseña',
    ABOUT: 'Términos y condiciones',
    CLOSE_SESSION: 'Cerrar sesión',
    TITLE_EDIT: 'Editar perfil'
};

const SETTINGS = {
    TITLE: 'Configuración',
    PUSH: 'Recibir notificaciones push',
    EMAIL: 'Recibir notificaciones por email'
};

const CHANGE_PASSWORD = {
    TITLE: 'Cambiar contraseña',
    PASSWORDS_MISMATCH: 'NO COINCIDEN LAS CONTRASEÑAS',
    OLD: 'contraseña actual',
    NEW: 'nueva contraseña',
    CONFIRM_NEW: 'repite la nueva contraseña'
};

const ABOUT = {
    VERSION: 'Versión',
    APP_BY: '· Una aplicación de LatamAutos Inc.',
    TITLE_SENT: 'Sugerencia enviada',
    SUBTITLE_SENT: 'Gracias por tus comentarios, nos ayudan a  mejorar nuestros servicios.',
};
const ERROR = {
    NoAssociatedUserGroupsError: 'Este usuario no tiene grupos asociados',
    InvalidCredentialsError: 'Usuario o contraseña incorrecta',
    LOGIN_DEFAULT: 'Ocurrió un error al iniciar sesión',
    NO_BITUAJ_RESULT_WARNING: 'Al momento no podemos obtener el valor del seguro',
    APPLICANT_HAS_ANOTHER_APPLICATION_ERROR: 'Ya existe una solicitud con este rfc',
    USERNAME_ALREADY_EXIST_ERROR: 'Ya existe la cuenta',
    INVALID_NIP_CODE_ERROR: 'Código Inválido',
    UNKNOWN_ERROR: 'Ocurrió un error',
};

const COUNTRY_SELECTOR = {
    SELECT_COUNTRY: 'Selecciona tu país'
};

const GROUP_SELECTOR = {
    SELECT_GROUP: 'Selecciona la cuenta'
};

const NAV_BUTTONS = {
    CREDIT: 'CRÉDITOS',
    CALCULATOR: 'CALCULADORA',
    ACCOUNT: 'CUENTA'
};

const PDF_LIST = {
    LOAN_APPLICATION: 'Solicitud de crédito',
    QUOTE: 'Cotización',
    INSURANCE: 'Seguro',
    GPS: 'Instalación de GPS',
    HEADER_NAME: 'NOMBRE',
    HEADER_CREATED_BY: 'CREADO POR',
    HEADER_CREATED_AT: 'FECHA DE CREACIÓN',
    HEADER_SIZE: 'TAMAÑO',
    DOC_TYPE_LOAN_APPLICATION: 'PDF_LOAN_APPLICATION',
    DOC_TYPE_PDF_INSURANCE: 'PDF_INSURANCE',
    DOC_TYPE_PDF_QUOTE: 'PDF_QUOTE',
    DOC_TYPE_PDF_GPS: 'PDF_GPS'
};

const FORBIDDEN = {
    TITLE: 'Acceso denegado',
    SUBTITLE: 'No tienes permitido acceder a la página solicitada.'
};

const QUOTA_AMORTIZATION = {
    FINANCING_AMOUNT: 'Total a financiar',
    MONTHLY_CAPITAL: 'Capital Mensual',
    MONTHLY_INTEREST: 'Interes Mensual',
    GPS_SDD: 'Gps + Ssd',
    MONTHLY_PAYMENT: 'Total Mensualidad',
    TOTAL_CAPITAL: 'Total capital',
    TOTAL_INTEREST: 'Total interés',
    TOTAL_PAY: 'Total a pagar',
    LOAN_APPLICATION_DATA: 'Datos de la solicitud',
    TOTAL_DATA: 'Datos de totales generados',
    AMORTIZATION_TABLE_TITLE: 'Tabla de Amortización',
    COMMISSION_AMOUNT: 'Comisión por apertura',
    INITIAL_PAYMENT: 'Pago Inicial',
    ANNUAL_RATE: 'Tasa anual',
    ANNUAL_RATE_IVA: 'Tasa anual con IVA',
    MONTHLY_RATE: 'Tasa mensual',
    MONTHLY_RATE_IVA: 'Tasa mensual con IVA',
    EXPORT_FILENAME: 'tabla-amortización.pdf'
};

export {
    GLOBAL,
    LOGIN,
    LOAN_APPLICATION,
    CALCULATOR,
    CALCULATOR_MX,
    NOTIFICATIONS,
    PROFILE,
    SETTINGS,
    CHANGE_PASSWORD,
    ABOUT,
    ERROR,
    NAV_BUTTONS,
    COUNTRY_SELECTOR,
    GROUP_SELECTOR,
    LOAN_APPLICATION_MX,
    SUMMARY_MX,
    PDF_LIST,
    FORBIDDEN,
    QUOTA_AMORTIZATION
};
